import { EditorState, ContentBlock, SelectionState, genKey } from 'draft-js';
import Immutable, { OrderedMap } from 'immutable';

/**
 *
 * @param {Draft.EditorState} editorState
 * @param {string} refKey
 * @param {"before"|"after"} position
 */
export function insertBlock(editorState, refKey, position = 'after') {
	const content = editorState.getCurrentContent();
	const blockMap = content.getBlockMap();

	const refBlock = blockMap.get(refKey);
	const blocksBeforeRef = blockMap.takeUntil((value, key) => key === refKey);
	const blocksAfterRef = blockMap.skipUntil((value, key) => key === refKey).rest();

	const newBlock = new ContentBlock({
		key: genKey(),
		type: 'unstyled',
		text: '',
	});
	const newBlockMap = position === 'before' ?
		blocksBeforeRef
			.concat(
				OrderedMap({ [newBlock.getKey()]: newBlock }),
				OrderedMap({ [refBlock.getKey()]: refBlock }),
				blocksAfterRef
			).toOrderedMap() :
		blocksBeforeRef
			.concat(
				OrderedMap({ [refBlock.getKey()]: refBlock }),
				OrderedMap({ [newBlock.getKey()]: newBlock }),
				blocksAfterRef
			).toOrderedMap();
	const newContent = content.set('blockMap', newBlockMap);
	const newSelection = SelectionState.createEmpty(newBlock.getKey());
	const newEditorState = EditorState.push(editorState, newContent, 'insert-fragment');

	// return newEditorState;
	return EditorState.forceSelection(newEditorState, newSelection);
}



// WEBPACK FOOTER //
// ./lib/helpers/insertBlock.js